import { forwardRef, useRef, createElement } from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import { useLocalization } from '../Provider/Provider.js';
import { Root, Anchor, Content } from '@radix-ui/react-popover';
import { Input } from '../Input/Input.js';
import { ScrollableList } from '../Listbox/ScrollableList.js';
import { useCombobox } from './useCombobox.js';
import { useBoundingClientRectListener } from '../../utils/hooks/useBoundingClientRectListener.js';

const Combobox = /*#__PURE__*/forwardRef(function Combobox(props, ref) {
  const {
    className: externalClassName,
    dialog,
    style,
    ...otherProps
  } = props;
  const {
    combobox,
    button,
    input,
    popover,
    list
  } = useCombobox(otherProps, ref);
  const internalRef = useRef(null);
  const {
    texts
  } = useLocalization();
  const selectDimensions = useBoundingClientRectListener(internalRef);
  const className = cn('inline-flex relative', {
    'yt-combobox--inline': props.inline
  }, externalClassName);
  return createElement("span", {
    className: className,
    "data-taco": "combobox",
    style: style
  }, createElement(Root, Object.assign({}, popover), createElement(Anchor, {
    asChild: true,
    ref: internalRef
  }, createElement("div", Object.assign({}, combobox, {
    className: "inline w-full",
    ref: ref
  }), createElement(Input, Object.assign({}, input, {
    autoComplete: "off",
    button: props.inline ? createElement(IconButton, {
      appearance: "discrete",
      className: "!border-l-0 focus:!border-none focus:!shadow-none active:!border-none",
      icon: popover.open ? 'chevron-up' : 'chevron-down',
      onClick: () => {
        var _input$ref$current;

        popover.onOpenChange(true);
        (_input$ref$current = input.ref.current) === null || _input$ref$current === void 0 ? void 0 : _input$ref$current.focus();
      },
      tabIndex: -1
    }) : dialog ? createElement(IconButton, {
      "aria-label": texts.combobox.tooltip,
      icon: "list-search",
      disabled: props.readOnly || props.disabled,
      dialog: dialog,
      onFocus: event => {
        var _input$ref$current2;

        // Prevents the default focus behaviour of showing the tooltip, on parent tooltip element
        event.preventDefault();
        (_input$ref$current2 = input.ref.current) === null || _input$ref$current2 === void 0 ? void 0 : _input$ref$current2.focus();
      },
      ref: button.ref,
      tabIndex: -1,
      tooltip: texts.combobox.tooltip
    }) : undefined
  })))), createElement(Content, {
    align: "start",
    onOpenAutoFocus: event => {
      event.preventDefault();
    },
    sideOffset: 4
  }, createElement(ScrollableList, Object.assign({}, list, {
    className: cn('!border-blue max-h-[calc(12rem+2px)] w-auto max-w-[theme(spacing.96)]'),
    style: {
      minWidth: selectDimensions === null || selectDimensions === void 0 ? void 0 : selectDimensions.width
    },
    tabIndex: popover.open ? 0 : -1
  })))));
});

export { Combobox };
//# sourceMappingURL=Combobox.js.map
